import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Navbar from './components/Navbar';
import OrderTracker from './components/OrderTracker';
import DeliveryPopup from './components/DeliveryPopup';
import Login from './Login'; // Ab ye popup ke taur par use hoga
import Registration from './components/Registeration'; // Ab ye popup ke taur par use hoga

// Pages
import Home from './pages/Home';
import StoreLocator from './components/StoreLocator';
import MyOrders from './components/MyOrders';
import MyFavourite from './components/MyFavourite';
import CartItemsDetails from './components/CartItemsDetails';

// Hook Import
import { useThemeColors } from './hooks/useThemeColors';
import './App.css';
import { getAvailableGetDarkMode } from './redux/pos/posSlice';
import { useSelector } from 'react-redux';
import CartForResponsive from './components/CartForResponsive';

function App() {
  const isDark = useSelector(getAvailableGetDarkMode);
  const { themeBg, textColor } = useThemeColors();

  // Popups States
  const [showTracker, setShowTracker] = useState(false);
  const [showCartForResponsive, setShowCartForResponsive] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    document.body.style.backgroundColor = themeBg;
    document.body.style.color = textColor;
    document.body.className = isDark ? 'dark-theme' : 'light-theme';
  }, [isDark, themeBg, textColor]);

  const openRegister = () => {
    setShowLogin(false);
    setShowRegister(true);
  };

  const openLogin = () => {
    setShowRegister(false);
    setShowLogin(true);
  };

  return (
    <Router>
      <div
        className={`app-container ${isDark ? 'dark' : 'light'}`}
        style={{
          backgroundColor: themeBg,
          color: textColor,
          minHeight: '100vh',
          transition: 'background-color 0.3s ease',
        }}
      >
        <Navbar
          darkMode={isDark}
          onOpenTracker={() => setShowTracker(true)}
          onOpenDelivery={() => setShowDelivery(true)}
          onOpenLogin={() => setShowLogin(true)}
          onOpenCart={() => setShowCartForResponsive(true)} // <--- YEH LINE ADD KAREIN
        />

        {/* --- Global Overlays for Popups --- */}
        {(showTracker ||
          showDelivery ||
          showLogin ||
          showRegister ||
          showCartForResponsive) && (
          <div
            className="popup-overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.7)',
              zIndex: 1050,
            }}
            onClick={() => {
              setShowTracker(false);
              setShowDelivery(false);
              setShowLogin(false);
              setShowRegister(false);
              setShowCartForResponsive(false); // <--- YEH LINE ADD KAREIN
            }}
          />
        )}

        {/* --- Popups Logic --- */}
        <OrderTracker
          isOpen={showTracker}
          onClose={() => setShowTracker(false)}
          darkMode={isDark}
        />

        <CartForResponsive
          isOpen={showCartForResponsive}
          onClose={() => setShowCartForResponsive(false)}
          darkMode={isDark}
        />

        <DeliveryPopup
          show={showDelivery}
          onClose={() => setShowDelivery(false)}
          darkMode={isDark}
        />

        {/* Login Popup */}
        {showLogin && (
          <div
            className="custom-popup-wrapper position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1200,
              backgroundColor: 'rgba(0,0,0,0.4)',
              backdropFilter: 'blur(2px)',
            }}
          >
            <Login
              isPopup={true}
              onClose={() => setShowLogin(false)}
              onSwitchToRegister={openRegister}
              darkMode={isDark}
            />
          </div>
        )}

        {/* Registration Popup */}
        {showRegister && (
          <div
            className="custom-popup-wrapper position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1200,
              backgroundColor: 'rgba(0,0,0,0.4)',
              backdropFilter: 'blur(2px)',
            }}
          >
            <Registration
              isPopup={true}
              onClose={() => setShowRegister(false)}
              onSwitchToLogin={openLogin}
              darkMode={isDark}
            />
          </div>
        )}

        {/* --- Main Content Routes --- */}
        <div className="main-content" style={{ backgroundColor: themeBg }}>
          <Routes>
            <Route path="/" element={<Home darkMode={isDark} />} />
            <Route
              path="/storeLocator"
              element={<StoreLocator darkMode={isDark} />}
            />
            <Route path="/myOrders" element={<MyOrders darkMode={isDark} />} />
            <Route
              path="/myFavourite"
              element={<MyFavourite darkMode={isDark} />}
            />
            <Route
              path="/cartItemsDetails"
              element={<CartItemsDetails darkMode={isDark} />}
            />
          </Routes>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={2000}
          theme={isDark ? 'dark' : 'light'}
        />
      </div>
    </Router>
  );
}

export default App;
